import { useState, useEffect } from "react";
import { useAppSelector } from "./app/hooks";
import { Stage as PixiStage } from "@pixi/react";
import { ReactReduxContext } from "react-redux";
import Loader from "./features/pool/loader";
import PoolScene from "./features/pool/pool";

// the context bridge:
const ContextBridge = ({ children, Context, render }) => {
  return (
    <Context.Consumer>
      {(value) =>
        render(<Context.Provider value={value}>{children}</Context.Provider>)
      }
    </Context.Consumer>
  );
};

const Stage = ({ children, ...props }) => {
  return (
    <ContextBridge
      Context={ReactReduxContext}
      render={(children) => <PixiStage {...props}>{children}</PixiStage>}
    >
      {children}
    </ContextBridge>
  );
};

function Pool(props) {
  const width = 2000;
  const height = 1125;
  const [scale, setScale] = useState(
    window.innerWidth / window.innerHeight < width / height
      ? window.innerWidth / width
      : window.innerHeight / height
  );

  useEffect(() => {
    const handleWindowResize = () => {
      setScale(
        window.innerWidth / window.innerHeight < width / height
          ? window.innerWidth / width
          : window.innerHeight / height
      );
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [setScale]);

  const loadingAssets = useAppSelector((state) => state.app.loadingAssets);
  return (
    <Stage
      width={width * scale}
      height={height * scale}
      className={props.className}
      options={{ backgroundColor: 0xffffff }}
    >
      {loadingAssets ? <Loader /> : <PoolScene />}
    </Stage>
  );
}

export default Pool;
